export default class DateUtils {
  static convertMinutesToMiliseconds = (minutes: number): number => minutes * 60 * 1000;

  static getFormattedDateFromString = (date: string, locale: string) : string => {
    return new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long' }).format(new Date(date));
  };

  static getFormattedDate = (date: Date, locale: string) : string => {
    return new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long' }).format(date);
  };

  static getFormatDateLocalString = (dateString: string, locale:string) :string => {
    const date = new Date(dateString);
    const datePart = date.toLocaleDateString(locale, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
    const weekday = date.toLocaleDateString(locale, { weekday: 'long' });

    return `${datePart} ${weekday}`;
  };

  static isValidDeliveryDate = (date : string) : boolean => {
    return date && /^\d{4}-\d{2}-\d{2}$/.test(date.trim());
  };

  static isValidDeliveryTime = ( time: string) : boolean => {
    return time && /^\d{1,2}:\d{2}\s*-\s*\d{1,2}:\d{2}$/.test(time.trim());
  };
}
